import Editor, { useMonaco } from "@monaco-editor/react";
import React, { useCallback, useContext, useEffect, useRef } from "react";
import { DynamicFormUtilsDataContext } from "../..";
import UserContext from "../../../../contexts/user";
import styles from "../../components.module.css";
import FieldHeader from "../FieldHeader";

function Code({ parameters, value, onChange, id, utilsData }) {
  /* TODO
   *   Implémenter le moyen d'extraire les context code de tous les modules
   *   au chargement d'un nouveaux flux
   *   Peut être le faire dans le composant DynamicForm ?
   *
   */

  const [dynamicFormUtilsDataContext, updateContext] = useContext(
    DynamicFormUtilsDataContext
  );

  const [userState] = useContext(UserContext);

  const monaco = useMonaco();
  const ref = useRef(null);

  const manageChange = function (value) {
    let pattern = /([a-zA-Z_]+[a-zA-Z0-9_]*)\s*=\s*\.*\s*;?/g;

    let matches = value.match(pattern);

    if (matches) {
      let variables = matches.map((match) => match.split("=")[0]);
      //setCodeVariables(Array.from(new Set(variables)));

      let codeContext = dynamicFormUtilsDataContext.codeContext?.data || {};
      codeContext[id] = Array.from(new Set(variables)).filter((name) => {
        return name.includes("DATA_");
      });

      //upate context
      updateContext({
        ...dynamicFormUtilsDataContext,
        codeContext: {
          ...dynamicFormUtilsDataContext.codeContext,
          data: codeContext,
        },
      });
    }

    if (userState.currentApp === "call-bot") {
      onChange({
        is_code: true,
        code: value,
        language: getLanguage(),
      });
    } else {
      onChange(value);
    }
  };

  useEffect(() => {
    if (
      parameters.default &&
      JSON.stringify(parameters.default) === JSON.stringify(value)
    ) {
      manageChange(
        typeof parameters.default === "object"
          ? JSON.stringify(parameters.default)
          : parameters.default
      );
    }
  }, []);

  useEffect(() => {
    // appelé 2 fois ! il faut corriger !!!!

    let disposable = null;
    if (monaco && dynamicFormUtilsDataContext.codeContext) {
      disposable = monaco.languages.registerCompletionItemProvider("python", {
        provideCompletionItems: function (model, position) {
          const word = model.getWordUntilPosition(position);

          const suggestions = [
            ...Object.values(
              dynamicFormUtilsDataContext.codeContext?.data || []
            ),
            ...Object.values(
              dynamicFormUtilsDataContext.codeContext?.meta_data || []
            ),
            ...Object.values(
              dynamicFormUtilsDataContext.codeContext?.output || []
            ),
          ].flat();

          return {
            suggestions: suggestions
              .filter((value, index) => {
                return suggestions.indexOf(value) === index;
              })
              .map((name) => {
                return {
                  label: name,
                  kind: monaco.languages.CompletionItemKind.Function,
                  documentation: "",
                  insertText: name,
                  range: {
                    startLineNumber: position.lineNumber,
                    endLineNumber: position.lineNumber,
                    startColumn: word.startColumn,
                    endColumn: word.endColumn,
                  },
                };
              }),
          };
        },
      });
    }
    return () => {
      disposable?.dispose();
    };
    /* return () => {
      monaco?.languages.registerCompletionItemProvider("python", () => {
        return {
          suggestions: [],
        };
      });
    }; */
  }, [dynamicFormUtilsDataContext.codeContext]);

  const getLanguage = useCallback(() => {
    return parameters.language || "json";
  }, [parameters]);

  const getWindowSize = function () {
    let size = null;
    switch (parameters.windowSize) {
      case "small":
        size = "50px";
        break;
      case "medium":
        size = "200px";
        break;
      case "large":
        size = "300px";
        break;
      default:
        size = "300px";
        break;
    }
    return size;
  };

  return (
    <div className={styles.reverse_form_control}>
      <FieldHeader
        label={parameters.label}
        description={parameters.description}
      />
      <div>
        <div>
          <span>language: </span>
          <span>{getLanguage()}</span>
        </div>
        <div className={styles.code_container}>
          <Editor
            ref={ref}
            height={getWindowSize()}
            language={getLanguage()}
            theme="vs-dark"
            options={{
              minimap: {
                enabled: false,
              },
              lineNumbersMinChars: 2,
              wordWrap: "on",
              indentation: "spaces",
              tabSize: 2,
              fontSize: "15px",
            }}
            value={
              value?.code
                ? value.code.toString()
                : value
                ? value.toString()
                : ""
            }
            onChange={manageChange}
            defaultValue={parameters.placeholder}
          />
        </div>
      </div>
    </div>
  );
}

export default Code;
